import { NestedTranslateStrings, TranslateString } from '@/types/translation.types';
import { BrandliveEvent } from '@/types/projects.types';
import { Get, Post, Put } from '../helpers';
import { replaceApexDomainForCurrentHost } from '@/utils/connections/replace-apex-domain-for-current-host';

export const GenerateGeneralTranslation = async ({
  content,
  languages,
  defaultLanguage,
  translateKeys,
}: {
  content: string | { [key: string]: string };
  languages: string[];
  defaultLanguage: string;
  translateKeys?: string[];
}): Promise<NestedTranslateStrings | TranslateString> => {
  return Post({
    path: `/v3/admin/events/generate-general-translation`,
    body: { content, languages, defaultLanguage, translateKeys },
  });
};

export type TranslationUploadWarning = {
  type: 'Missing Key' | 'Missing Cell' | 'Incorrect Language';
  value: string;
  metadata?: { sheet: string; key: string; value: string };
};

export type TranslationUploadResult = {
  manifests: Record<string, string>;
  warnings: TranslationUploadWarning[];
};

const TRANSLATIONS_HOST = replaceApexDomainForCurrentHost(import.meta.env.VITE_TRANSLATIONS_SERVICE_HOST as string);

export const downloadTranslationFile = (eventUuid: string): Promise<Response> =>
  Get<Response>({
    url: `${TRANSLATIONS_HOST}/translation/${eventUuid}`,
    returnResponse: true,
  });

export const uploadTranslationFile = async (
  file: File,
  eventUuid: string,
  language: string
): Promise<TranslationUploadResult> => {
  const formData = new FormData();
  formData.append('file', file);
  return Put<TranslationUploadResult>({
    host: TRANSLATIONS_HOST,
    path: `/translation/${eventUuid}/${language}`,
    body: formData,
  });
};

export const saveTranslationFile = async (eventUuid: string, manifests: Record<string, string>): Promise<void> => {
  return Put<void>({
    host: TRANSLATIONS_HOST,
    path: `/translation/${eventUuid}/save`,
    body: { manifests },
  });
};

export const commitTranslationFile = (eventUuid: string): Promise<BrandliveEvent> =>
  Put<BrandliveEvent>({ path: `/v3/admin/events/${eventUuid}/translations` });
